import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

/** Read the persisted language from the Zustand settings store (localStorage). Defaults to 'ja'. */
function getStoredLanguage(): string {
  try {
    const stored = localStorage.getItem("fivevai-settings-storage");
    if (stored) {
      const parsed = JSON.parse(stored) as { state?: { language?: string } };
      const lang = parsed?.state?.language;
      if (lang === "en" || lang === "ja") return lang;
    }
  } catch {
    // ignore parse errors
  }
  return "ja"; // default language for new users
}

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getStoredLanguage(),
    fallbackLng: "ja",
    supportedLngs: ["en", "ja"],
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      // Version the stable locale URL so a previously cached translation file
      // cannot leave newly deployed keys visible in the UI.
      loadPath: `${import.meta.env.BASE_URL.replace(/\/$/, "")}/locales/{{lng}}/translation.json?v=20261102-1`,
    },
  });

export default i18n;
